<template>
  <div class="page-container">
    <div class="page-card">
      <div class="page-card__header">
        <h1 class="section-title">行业资讯</h1>
      </div>
      <div class="page-card__body">
        <a
          v-for="item in tableData"
          :key="item.id"
          :href="item.linkUrl"
          target="_blank"
          class="news-list-item"
        >
          <div class="news-list-item__thumb">
            <img :src="item.mainImgUrl" :alt="item.title" />
          </div>
          <div class="news-list-item__content">
            <p class="news-list-item__title">{{ item.title }}</p>
            <span class="news-list-item__date">{{ item.publishDate }}</span>
          </div>
        </a>
        <div v-if="!tableData.length" class="empty-tip">暂无数据</div>
        <div class="pagination-wrap">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            :current-page="pageNo"
            :page-size="pageSize"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { industryNews } from '@/api/cmsApi'

export default {
  name: 'IndustryInformation',
  data() {
    return {
      tableData: [],
      pageNo: 1,
      pageSize: 5,
      total: 0
    }
  },
  created() {
    this.query()
  },
  methods: {
    query() {
      industryNews({ pageNo: this.pageNo, pageSize: this.pageSize }).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.records
          this.total = res.data.total
        }
      })
    },
    handleCurrentChange(page) {
      this.pageNo = page
      this.query()
    }
  }
}
</script>

<style scoped>
.empty-tip {
  text-align: center;
  color: var(--color-text-muted);
  padding: 40px 0;
}
</style>
